// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import React, { type JSX } from "react";

import { type UserRole } from "../../hooks/atoms";
import { useCurrentUser } from "../../hooks/useCurrentUser";

interface Props {
  children: JSX.Element;
  privileges: UserRole[];
  fallback?: React.ReactNode;
  bypass?: boolean;
}

const RequirePrivilege: React.FC<Props> = ({
  children,
  privileges,
  fallback,
  bypass,
}) => {
  const { data: user } = useCurrentUser();
  return bypass || (user?.role && privileges.includes(user.role))
    ? children
    : (fallback ?? null);
};

export default RequirePrivilege;
